// =============================================================
// highlevelAppointmentsService
// Service layer for HighLevel Calendars / Appointments API.
// Live mode (future): https://services.leadconnectorhq.com/calendars/
// v1: mock JSON. Class-booking semantics (capacity, show/no-show)
// mirror HighLevel's class booking calendar concepts.
// =============================================================

import { APPOINTMENTS } from "../data/mockData";

const LIVE_API_ENABLED = false;
const simulateLatency = (data, ms = 120) => new Promise((res) => setTimeout(() => res(data), ms));

export const highlevelAppointmentsService = {
  isLive: () => LIVE_API_ENABLED,

  /** All appointments (optionally by branch / date) */
  async listAppointments(filters = {}) {
    let rows = [...APPOINTMENTS];
    if (filters.branch) rows = rows.filter((a) => a.location_branch === filters.branch);
    if (filters.dateISO) {
      const day = filters.dateISO.slice(0, 10);
      rows = rows.filter((a) => a.date_time.slice(0, 10) === day);
    }
    rows.sort((a, b) => new Date(a.date_time) - new Date(b.date_time));
    return simulateLatency(rows);
  },

  /** Upcoming confirmed trials */
  async upcomingTrials(limit = 6) {
    const rows = APPOINTMENTS.filter((a) => new Date(a.date_time) > new Date() && a.status === "confirmed")
      .sort((a, b) => new Date(a.date_time) - new Date(b.date_time))
      .slice(0, limit);
    return simulateLatency(rows);
  },

  /** Days (ISO yyyy-mm-dd) that have at least one appointment */
  async bookedDays() {
    const days = [...new Set(APPOINTMENTS.map((a) => a.date_time.slice(0, 10)))];
    return simulateLatency(days);
  },
};
